export const counties = {
  monmouth: {
    label: "Monmouth County - July 2025",
    geojsonPath: "https://pub-fcc535d59ae74363b41e79d9fc20d25e.r2.dev/data/monmouthjuly.geojson",
  },
  monmouthjune: {
    label: "Monmouth County - June 2025",
    geojsonPath: "https://pub-fcc535d59ae74363b41e79d9fc20d25e.r2.dev/data/monmouthjune.geojson",
  },
  // You can add more counties later using the same format
};

//https://pub-fcc535d59ae74363b41e79d9fc20d25e.r2.dev/data/monmouth.geojson